<div id="agencia-confirmado">
    <div class="modal-content ">
      <div class="modal-header d-block mt-5 border-0 text-center">
        
        <h3 class="modal-title text-secondary text-center m-auto" id="loginLabel" style="color: #0099ff;">¿Seguro que desea dar baja al pasajero?</h3>
        <i class="bi-x modal-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></i>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-1"></div>
          <div class="col-10 text-center z-index--top" style="padding-bottom: 50px;">
            <p class="mb-5">Esta accion no tiene vuelta atras</p>
            <a  style="cursor: pointer;" class="btn btn-lg btn-primary btn-reservar rounded-pill" (click)="cancelar()" >Cancelar</a>
            <a  class="btn btn-lg btn-primary btn-reservar rounded-pill" (click)="aceptar()" style="margin-left: 30px; cursor: pointer;"> Aceptar </a>
            
          </div>
          <div class="col-1"></div>
          
        </div>
      </div>
      <div class="modal-footer mb-4 border-0 bg-foot">
       <!--<img src="/assets/images/body/register-pending-1.svg" class="left" alt="">  -->
      </div>
    </div>    
  </div>
